module.exports = __webpack_public_path__ + "media/images/yesbank-logo-4f5a7384f152745d7d42f0adb707b2b7.png";